export class PackItemDTO implements PackItem {
  constructor({
    id,
    name,
    img,
    count,
    type,
    price,
    grade,
    isLock
  }: Partial<PackItem>) {
    this.id = id || 0;
    this.name = name || "";
    this.img = img || "";
    this.count = count || 0;
    this.type = type || "equipment";
    this.price = price || 0;
    this.isLock = isLock ?? false;
    this.grade = grade || 0;
  }
  id: number;
  name: string;
  img: string;
  count: number;
  type: PackItemType;
  price: number;
  grade: number;
  isLock: boolean;
}
